import { render, staticRenderFns } from "./MessagesTable.component.vue?vue&type=template&id=c13e22b8"
import script from "./MessagesTable.component.vue?vue&type=script&lang=ts"
export * from "./MessagesTable.component.vue?vue&type=script&lang=ts"
import style0 from "./MessagesTable.component.vue?vue&type=style&index=0&id=c13e22b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
